module.exports = __webpack_public_path__ + "img/coinbankB40.88142718.jpg";